import { render } from "./UseAsMemberButton.vue?vue&type=template&id=e06c5cac"
import script from "./UseAsMemberButton.vue?vue&type=script&lang=js"
export * from "./UseAsMemberButton.vue?vue&type=script&lang=js"
script.render = render

export default script